import type { CRTVarPatch, SequencerStep } from "./types";

const step = (index: number): SequencerStep => ({
  enabled: [0, 3, 7, 10, 12, 15].includes(index),
  note: [48, 48, 55, 51, 60, 55, 63, 58][index % 8],
  velocity: index % 4 === 0 ? 0.9 : 0.64,
  gate: 0.58,
});

export const DEFAULT_PATCH: CRTVarPatch = {
  format: "crtvar-patch",
  schemaVersion: 3,
  name: "Cold boot",
  seed: 0x43525456,
  engine: { modelRevision: "ntsc-m-1" },
  source: { kind: "bars", fit: "fit" },
  synth: {
    osc1: { waveform: "saw", octave: 0, detune: -7, level: 0.72 },
    osc2: { waveform: "square", octave: -1, detune: 7, level: 0.58 },
    noiseLevel: 0.08,
    cutoff: 2400,
    resonance: 0.22,
    attack: 0.018,
    decay: 0.2,
    sustain: 0.62,
    release: 0.42,
    lfoWaveform: "triangle",
    lfoRate: 1.7,
    drive: 0.18,
  },
  video: {
    mode: "image",
    horizontalJitter: 0.12,
    verticalRoll: 0,
    chromaPhase: 0,
    chromaGain: 1,
    noise: 0.08,
    feedback: 0.18,
    burstAmplitude: 1,
    linePosition: 0.48,
    lineWidth: 0.05,
    gain: 1,
    offset: 0,
    syncOffset: 0,
    clipping: 0,
    solarize: 0,
    receiverTracking: 0.72,
    receiverBandwidth: 0.62,
    scopeLine: 240,
  },
  modulationRoutes: [
    { id: "route-lfo-sync", source: "lfo1", target: "video.horizontalJitter", depth: 0.22, smoothingMs: 40, enabled: true },
    { id: "route-rms-chroma", source: "audioRms", target: "video.chromaPhase", depth: -0.18, smoothingMs: 80, enabled: true },
    { id: "route-env-noise", source: "envelope", target: "video.noise", depth: 0.14, smoothingMs: 24, enabled: true },
  ],
  keyboard: { octave: 3, capture: true },
  sequencer: { enabled: false, bpm: 118, swing: 0.08, steps: Array.from({ length: 16 }, (_, index) => step(index)) },
  midiMappings: [],
};

export const FACTORY_PRESETS: CRTVarPatch[] = [
  DEFAULT_PATCH,
  {
    ...structuredClone(DEFAULT_PATCH),
    name: "Chroma weather",
    seed: 0x19790701,
    video: { ...DEFAULT_PATCH.video, chromaPhase: 38, chromaGain: 1.34, noise: 0.21, feedback: 0.34, verticalRoll: 0.06 },
  },
  {
    ...structuredClone(DEFAULT_PATCH),
    name: "Receiver lost",
    seed: 0x52500002,
    video: { ...DEFAULT_PATCH.video, mode: "composite", horizontalJitter: 0.38, burstAmplitude: 0.44, syncOffset: 2.25, receiverTracking: 0.28 },
  },
  {
    ...structuredClone(DEFAULT_PATCH),
    name: "Quiet grid",
    seed: 0x0000c0de,
    source: { kind: "grid", fit: "fit" },
    video: { ...DEFAULT_PATCH.video, horizontalJitter: 0.02, noise: 0.015, feedback: 0, chromaGain: 0.72 },
  },
];
